import { render, staticRenderFns } from "./VEmployerEmployeesTemplateDocumentsBrowse.vue?vue&type=template&id=2726e0fc&lang=pug"
import script from "./VEmployerEmployeesTemplateDocumentsBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployeesTemplateDocumentsBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports